import { parse } from 'url';
import querystring from 'querystring';
import { isEmpty, isNil, pickBy } from 'ramda';
import { checkParam } from '../language-helpers/objects';

export function createURL({
  host,
  path,
  queryParams,
  hash,
}: {
  host: string;
  path: string;
  queryParams: Record<string, any>;
  hash?: string;
}) {
  const url = new URL(`${host}${path}`);

  Object.entries(queryParams).forEach(([key, value]) => {
    if (value === undefined || value === null) {
      return;
    }

    if (typeof value === 'object') {
      url.searchParams.set(key, JSON.stringify(value));
    } else {
      url.searchParams.set(key, value);
    }
  });

  if (hash) {
    url.hash = hash;
  }

  return url.toString();
}

export function appendQuery(path: string, query: Record<string, string>) {
  if (isNil(query)) {
    return path;
  }

  const filteredQuery = pickBy((val) => !isNil(val) && !isEmpty(val), query);
  if (isEmpty(filteredQuery)) {
    return path;
  }

  const queryStr = querystring.encode(filteredQuery as any);
  return `${path}?${queryStr}`;
}

export function appendResourceType(type: string, url: string) {
  checkParam({ type });
  checkParam({ url });

  const parsed = parse(url);

  const path = buildPath(type, parsed);

  if (!parsed.hostname) {
    return path;
  }

  return `${parsed.protocol}//${parsed.host}${path}`;
}

export function buildPath(
  type: string,
  { pathname, search }: { pathname: string | null; search: string | null }
) {
  if (search) {
    return `${pathname}.${type}${search}`;
  }
  return `${pathname}.${type}`;
}

const DOMAIN_REGEX =
  /^[a-zA-Z0-9]([a-zA-Z0-9]+[-.]?)*[a-zA-Z0-9]\.[a-zA-Z]{2,}$/;
export const isDomainValid = (domain?: string | null) =>
  !!(domain && domain.match(DOMAIN_REGEX));
